import { Component, OnInit } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Editor } from 'ngx-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SchoolForm } from '../../../../../core/request-forms/SchoolForm';
import { FileService } from '../../../../../core/services/file.service';
import { SchoolService } from '../../../../../core/services/school.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-school',
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        LoadingComponent,
        HeaderComponent,
        SampleSearchPipe,
        NgSelectModule,
        NgxPaginationModule,
        AngularEditorModule
    ],
    templateUrl: './school.component.html',
    styleUrls: ['./school.component.css']
})
export class SchoolComponent implements OnInit {

  fileSrc:any="https://placehold.co/200x200"
  loading=false
  fileInput:any
  editor: Editor = new Editor() ;
  data=SchoolForm
  isNew=true
  tag="admin-school"
  
  constructor(
    private spinnerService:NgxSpinnerService,
    private fileService:FileService,
    private schoolService:SchoolService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }

  ngOnInit(): void {
      this.editor = new Editor();
      this.getOne()

  }

getOne(){
  this.schoolService.getAll().subscribe((res:any)=>{
    if (res.data!=null) {
      this.isNew=false
      this.data.id=res.data.id
      this.data.code=res.data.code
      this.data.name=res.data.name
      this.data.acronym=res.data.acronym
      this.data.email=res.data.email
      this.data.phone=res.data.phone
      this.data.postal_box=res.data.postal_box
      this.data.description=res.data.description
      this.data.logo=res.data.logo
      this.fileSrc=this.data.logo
      // Sans logo enregistre, l'appel partait avec un nom de fichier vide et
      // remontait une erreur a l'ouverture de la page.
      if (res.data.logo) this.getFile('public','school',res.data.logo)
    }
    this.modalService.dismissAll()
  },
  (err:any)=>{
    AppErrorShow.showError("Gestion de l'établissement",err)

  })

}
  getFile(disk:any,folder:any,filename:any){
    //this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get({
      folder:folder,
      disk:disk,
      filename:filename
    }).subscribe((res:any)=>{
     // this.pdfViewLoader=false
     this.spinnerService.hide()
      this.fileSrc=res[0]
     // this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion de l'établissement",err)
    })
  }



  setData(value:any){
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
          formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
      formData.append("logo",this.fileInput)
    }
    console.log(this.isNew)
    if (this.isNew) {

      this.loading=true
      this.schoolService.store(formData).subscribe((res:any)=>{
        this.getOne()
        this.toastrService.info("Donnée de l'établissement mis à jour")
        this.modalService.dismissAll()
        this.loading=false
      },
      (err:any)=>{
        this.loading=false
        AppErrorShow.showError("Gestion de l'établissement",err)

      })
    } else {
      this.loading=true
      this.schoolService.update(this.data.id,formData).subscribe((res:any)=>{
        this.getOne()
        this.toastrService.info("Donnée de l'établissement mis à jour")
        this.modalService.dismissAll()
        this.loading=false
      },
      (err:any)=>{
        this.loading=false
        AppErrorShow.showError("Gestion de l'établissement",err)

      })
    }
  }

  

  readFile(){
    var reader = new FileReader();

    reader.readAsDataURL(this.fileInput); // read file as data url

    reader.onload = (event) => { // called once readAsDataURL is completed
      this.fileSrc = event.target?.result;
    }
  }

  loadImg(event:any){
    if(event.target.files.length!=0){
      this.fileInput=event.target.files[0]
      this.readFile()
    }
  }

  ngOnDestroy(): void {
    this.editor?.destroy();
  }

}
